import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IQuickDiffService = ( createDecorator('quickDiff'));
export { IQuickDiffService };
